import { doLogout } from 'actions/authAction';

import { BASE_URL } from 'actions/constant';

export const TRACKING_CONTAINER_GET_SUCCESS = "TRACKING_CONTAINER_GET_SUCCESS";

const trackingContainerGetSuccess = (bool, container, msg) => {
  return {
    type: TRACKING_CONTAINER_GET_SUCCESS,
    load: bool,
    val: container.data,
    msg:msg
  };
};

export function trackingContainerListAll(data) {
  return (dispatch) => {
      dispatch(trackingContainerGetSuccess(true, {data: []}, ''));

      let token = localStorage.getItem('tolaut@token') || null;
      let config = {};

      if(token) {
        config = {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }
      } else {
        throw Error("Authentication error");
      }

      fetch(BASE_URL + '/tracking-container', config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.status === 200) {
            dispatch(trackingContainerGetSuccess(false, data, ''));
        }
        else {
          dispatch(trackingContainerGetSuccess(false, {data: []}, data.msg));
        }
      })
      .catch((err) => {
        dispatch(trackingContainerGetSuccess(false, {data: []}, err));
      });
  };
};
